export const articleData = {
  "en": {
    "distributor": {
      "title": "Distributor Program | Sound Event Detector",
      "eyebrow": "DISTRIBUTOR PARTNER NETWORK",
      "lead": "Expand your security technology portfolio with modern Sound Event Detection hardware and zero-cost NFR (not for resell) SW licenses across all supported platforms (Axis, Hanwha, Hikvision...) backed by dedicated regional support, training, and reliable cooperation.",
      "h2": "Expand Your Security Portfolio with World-Class Acoustic AI",
      "p1": "As an authorized SED Distributor, you become the primary regional source for edge AI acoustic security technology. Demand for non-invasive sound event classification is accelerating globally across municipal, healthcare, industrial, and banking markets.",
      "p2": "We equip distributors with hardware demonstration kits, zero-cost NFR (not for resell) SW licenses for your tests and product demonstrations across all supported platforms (Axis, Hanwha, Hikvision, etc.), and direct access to our engineering team in Pilsen, Czech Republic.",
      "h3": "Why Partner with JALUD Embedded?",
      "b1_title": "Territorial Exclusivity & Deal Protection",
      "b1_desc": "Registered projects receive commercial margin protection and regional preference.",
      "b2_title": "Comprehensive Training & Certification",
      "b2_desc": "Technical sales enablement for your engineering and commercial staff.",
      "b3_title": "Privacy by Design & GDPR Compliance",
      "b3_desc": "Zero human speech recording ensures hassle-free municipal deployment approvals.",
      "b4_title": "SLA Engineering Support",
      "b4_desc": "Direct escalations to core R&D developer engineers.",
      "benefits": [
        "Exclusive territorial distribution rights & project registration protection",
        "Hardware demo kits & zero-cost NFR (not for resell) SW licenses for your tests and product demonstrations across all supported platforms (Axis, Hanwha, Hikvision, etc.)",
        "Direct technical engineering desk and sales training"
      ]
    },
    "integrator": {
      "title": "System Integrator | Advanced Sound Detection Solution Integration",
      "eyebrow": "VMS & HARDWARE INTEGRATION",
      "lead": "Offer advanced acoustic threat detection with native software for Hanwha, Axis, Hikvision cameras and direct integration into leading VMS platforms (Genetec, Milestone, Avigilon, Geutebrück, and many more).",
      "h2": "Seamless VMS Integration Without Changing Existing Cameras",
      "p1": "Modern security clients demand integrated solutions rather than isolated silos. SED empowers System Integrators to add acoustic detection seamlessly into existing video management software (VMS) without replacing existing camera hardware.",
      "p2": "When an acoustic event (gunshot, scream, glass break) occurs, SED immediately sends VMS metadata, triggers instant PTZ camera slewing to the sound coordinates, and notifies central operators in <5s.",
      "h3": "Integrator Advantages",
      "b1_title": "Native Edge Apps & Comprehensive VMS Integration",
      "b1_desc": "Native camera software for Hanwha, Axis, and Hikvision with pre-built integrations for leading VMS systems (Genetec, Milestone, Avigilon, Geutebrück, and many more). <a href=\"#solutions\" data-route=\"solutions\" style=\"color: var(--blue-primary); font-weight: 700; text-decoration: underline;\">Learn more in Solutions Overview →</a>",
      "b2_title": "REST API & HTTP Webhooks",
      "b2_desc": "Flexible integration into custom PSIM or IoT smart city platforms.",
      "b3_title": "Zero Maintenance Overhead",
      "b3_desc": "Automatic self-diagnostics and neural noise filtering.",
      "benefits": [
        "Zero-cost NFR (not for resell) SW licenses for your tests & product demonstrations across all supported platforms (Axis, Hanwha, Hikvision, etc.) & REST API SDK access",
        "Instant PTZ camera slewing & central control room alert integration",
        "Deal margin protection & pre-sales architectural validation"
      ]
    },
    "citizen": {
      "title": "Active Citizen | Improving Public Safety with SED",
      "eyebrow": "COMMUNITY SAFETY INITIATIVE",
      "lead": "Empowering citizens, neighborhood watches, and local community leaders to identify high-risk urban safety blind spots and collaborate with municipal police for faster crisis response.",
      "h2": "Making Cities Safer, Together",
      "p1": "Public safety is a collective responsibility. Citizens frequently notice unlit city parks, nightlife avenues, and transit stops where crime, panic altercations, or vandalism occur repeatedly.",
      "p2": "By advocating for Sound Event Detector deployment in your municipality, you help local police respond 7x faster to incidents while maintaining strict privacy standards under GDPR.",
      "h3": "How Active Citizens Can Help",
      "b1_title": "Petition Your Local City Council",
      "b1_desc": "Download our municipal proposal template for local safety committees.",
      "b2_title": "Identify Safety Blind Spots",
      "b2_desc": "Report high-risk public parks, schools, and public transport hubs.",
      "b3_title": "Reassure Privacy Concerns",
      "b3_desc": "Inform neighbors that SED processes sound locally on edge chips without recording conversations.",
      "benefits": [
        "Direct municipal petition templates for city council meetings",
        "Community safety awareness material & demonstration reports",
        "Zero-speech recording architecture aligned with GDPR"
      ]
    },
    "investor": {
      "title": "Investor Relations | Scaling European Deep-Tech AI",
      "eyebrow": "VENTURE & CAPITAL PARTNERSHIP",
      "lead": "Partner with JALUD Embedded s.r.o. in expanding high-growth acoustic AI technology across global municipal, defense, and industrial security markets.",
      "h2": "Fastest Growing Acoustic Deep-Tech Pioneer in Europe",
      "p1": "JALUD Embedded is an award-winning European technology leader headquartered in Pilsen, Czech Republic. Winner of the National AI Award, Vizionáři 2023, and the EU Seal of Excellence.",
      "p2": "Our proprietary neural edge algorithms process sound in <5s directly on low-power ARM and NPU microprocessors. With expanding distribution channels across Europe, North America, and Asia, JALUD Embedded offers investors high recurring software margin potential and defensible IP barriers.",
      "h3": "Investment Highlights",
      "b1_title": "Patented Neural Edge Technology",
      "b1_desc": "Microsecond audio DSP processing on low-cost hardware.",
      "b2_title": "Massive TAM Expansion",
      "b2_desc": "Smart cities, public transit, hospitals, schools, and defense installations.",
      "b3_title": "High Software Recurrence",
      "b3_desc": "SaaS licensing model coupled with hardware sales.",
      "benefits": [
        "Proprietary edge AI intellectual property & patents",
        "Exponential commercial expansion across EU, UK, and US markets",
        "Proven unit economics and high recurring software revenue"
      ]
    },
    "customer": {
      "title": "Customer Success & Enterprise SLA Maintenance",
      "eyebrow": "END-USER SUPPORT & REASSURANCE",
      "lead": "Comprehensive technical support, site acoustic surveys, firmware updates, and continuous neural classifier optimization for municipal and enterprise customers.",
      "h2": "End-to-End Enterprise Support & Continuous Optimization",
      "p1": "At Sound Event Detector, deployment is just the beginning. Our Customer Success Team ensures that every municipal council, hospital ER, energy plant, and retail customer achieves high operational reliability.",
      "p2": "We provide turn-key site acoustic surveys, mounting height recommendations, background noise calibration, and automatic over-the-air firmware updates to ensure your system improves over time.",
      "h3": "Customer Reassurance Commitments",
      "b1_title": "Dedicated Account Engineering",
      "b1_desc": "Direct contact with technical engineers for setup assistance.",
      "b2_title": "Lifetime Neural Retraining",
      "b2_desc": "Continuous model upgrades for new acoustic noise environments.",
      "b3_title": "ISO 27001 / ISO 9001 SLA Guarantees",
      "b3_desc": "Certified quality management and cyber security standards.",
      "benefits": [
        "Turn-key installation assistance & acoustic site mapping",
        "Dedicated technical desk support for contract clients",
        "Over-the-air firmware updates & continuous neural model upgrades"
      ]
    },
    "partner": {
      "title": "Technology & OEM Partnership Program",
      "eyebrow": "OEM & TECHNOLOGY ALIGNMENT",
      "lead": "Co-develop specialized hardware modules, camera edge chips, smart city lighting poles, and security robotics powered by SED acoustic AI neural algorithms.",
      "h2": "Embed Sound Detection Into Next-Generation Hardware",
      "p1": "JALUD Embedded collaborates with leading hardware manufacturers, camera vendors, smart streetlight providers, and security robotics companies to embed Sound Event Detector neural algorithms directly into next-generation devices.",
      "p2": "Our lightweight C/C++ neural engine can run efficiently on low-power NPU, DSP, or ARM Cortex processors, giving hardware partners a competitive edge without heavy cloud bandwidth costs.",
      "h3": "OEM Integration Options",
      "b1_title": "DSP / NPU Firmware Licensing",
      "b1_desc": "Embed SED algorithms into camera SoCs or smart streetlights.",
      "b2_title": "Custom Sound Dataset R&D",
      "b2_desc": "Train custom classifiers for industrial machinery or proprietary events.",
      "b3_title": "Co-Branded Marketing & Patent Licensing",
      "b3_desc": "Joint GTM product releases and global trade show showcases.",
      "benefits": [
        "Embedded NPU/DSP neural algorithm licensing",
        "Custom acoustic AI classifier R&D & dataset collection",
        "Joint patent & co-branded technology launches"
      ]
    }
  },
  "cs": {
    "distributor": {
      "title": "Distributorský program",
      "eyebrow": "PARTNERSKÁ SÍŤ DISTRIBUTORŮ",
      "lead": "Rozšiřte své portfolio bezpečnostních technologií o moderní hardwarové detektory zvuku a bezplatné NFR (not for resell) softwarové licence na všech podporovaných platformách (Axis, Hanwha, Hikvision...) s přímou regionální podporou a školením.",
      "h2": "Rozšiřte své bezpečnostní portfólio o špičkovou akustickou AI",
      "p1": "Jako autorizovaný distributor SED se stáváte primárním regionálním dodavatelem edge AI akustické technologie. Poptávka po neinvazivní detekci zvukových událostí celosvětově roste v oblastech městské bezpečnosti, zdravotnictví, průmyslu a bankovnictví.",
      "p2": "Vybavíme distributory předváděcími hardwarovými sadami, bezplatnými NFR (not for resell) softwarovými licencemi pro vaše testování a demonstrace produktů na všech podporovaných platformách (Axis, Hanwha, Hikvision atd.) a přímým přístupem k našemu vývojovému týmu v Plzni.",
      "h3": "Proč se stát partnerem JALUD Embedded?",
      "b1_title": "Exkluzivita území a ochrana projektů",
      "b1_desc": "Registrované projekty získávají garantovanou ochranu marže a regionální přednost.",
      "b2_title": "Komplexní školení a certifikace",
      "b2_desc": "Technická a obchodní příprava pro vaše inženýry a obchodní zástupce.",
      "b3_title": "Ochrana soukromí dle GDPR",
      "b3_desc": "Nenahrávání lidské řeči garantuje bezproblémové schválení městskými úřady.",
      "b4_title": "SLA inženýrská podpora",
      "b4_desc": "Přímá eskalace dotazů na vývojové inženýry.",
      "benefits": [
        "Exkluzivní teritoriální práva a ochrana registrace projektů",
        "Předváděcí hardwarové sady a bezplatné NFR (not for resell) SW licence pro vaše testy a demonstrace produktů na všech podporovaných platformách (Axis, Hanwha, Hikvision atd.)",
        "Přímá technická inženýrská podpora a prodejní školení"
      ]
    },
    "integrator": {
      "title": "Integrace SED do bezpečnostních systémů",
      "eyebrow": "INTEGRACE VMS A HARDWARU",
      "lead": "Nabídněte pokročilou detekci zvukových událostí s nativním softwarem pro kamery Hanwha, Axis, Hikvision a integrací do předních VMS (Genetec, Milestone, Avigilon, Geutebrück a dalších).",
      "h2": "Snadná VMS integrace bez nutnosti výměny stávajících kamer",
      "p1": "Moderní klienti vyžadují integrovaná řešení. SED umožňuje systémovým integrátorům snadno přidat akustickou detekci do stávajícího VMS softwaru bez nutnosti výměny kamer.",
      "p2": "Při výskytu akustické události (střelba, křik, rozbití skla) SED okamžitě odesílá VMS metadata, natáčí PTZ kamery na místo zvuku a upozorňuje operační středisko během <5s.",
      "h3": "Výhody pro integrátory",
      "b1_title": "Nativní Edge aplikace a široká VMS integrace",
      "b1_desc": "Nativní software pro kamery Hanwha, Axis a Hikvision s hotovými integracemi do předních VMS (Genetec, Milestone, Avigilon, Geutebrück a řady dalších). <a href=\"#solutions\" data-route=\"solutions\" style=\"color: var(--blue-primary); font-weight: 700; text-decoration: underline;\">Více v přehledu řešení →</a>",
      "b2_title": "REST API a HTTP Webhooky",
      "b2_desc": "Flexibilní integrace do vlastních PSIM nebo IoT systémů Smart City.",
      "b3_title": "Nulové nároky na údržbu",
      "b3_desc": "Automatická autodiagnostika a neuronová filtrace šumu.",
      "benefits": [
        "Bezplatné NFR (not for resell) SW licence pro vaše testy a demonstrace na všech podporovaných platformách (Axis, Hanwha, Hikvision atd.) a přístup k REST API SDK",
        "Okamžité natáčení PTZ kamer a integrace poplachů do velína",
        "Ochrana marže projektů a předprodejní architektonická validace"
      ]
    },
    "citizen": {
      "title": "Občanská spolupráce pro bezpečnější města",
      "eyebrow": "INICIATIVA MĚSTSKÉ BEZPEČNOSTI",
      "lead": "Zapojení občanů a komunitních lídrů do identifikace rizikových míst ve městech a spolupráce s městskou policií pro rychlejší zásah v krizových situacích.",
      "h2": "Společně pro bezpečnější města",
      "p1": "Bezpečnost ve městech je společnou odpovědností. Občané často upozorňují na neosvětlená místa, městské parky a zastávky MHD, kde dochází k výtržnostem a vandalismu.",
      "p2": "Prosazováním nasazení Sound Event Detector ve vašem městě pomáháte policii reagovat 7x rychleji na incidenty při důsledné ochraně soukromí.",
      "h3": "Jak mohou aktivní občané pomoci",
      "b1_title": "Podání podnětu městské radě",
      "b1_desc": "Stáhněte si náš vzor návrhu pro bezpečnostní výbory měst.",
      "b2_title": "Identifikace rizikových míst",
      "b2_desc": "Hlášení nebezpečných parků, školních zón a uzlů MHD.",
      "b3_title": "Garance ochrany soukromí",
      "b3_desc": "Informujte sousedy, že SED zpracovává zvuk lokálně na čipu bez nahrávání hovorů.",
      "benefits": [
        "Vzory městských peticí pro jednání zastupitelstva",
        "Osvětové materiály a zprávy o bezpečnosti v obcích",
        "Soulad s GDPR bez nahrávání lidské řeči"
      ]
    },
    "investor": {
      "title": "Investiční partnerství",
      "eyebrow": "INVESTIČNÍ A KAPITÁLOVÉ PARTNERSTVÍ",
      "lead": "Partnerství s JALUD Embedded s.r.o. při globální expanzi pokročilé akustické AI na trhy městské, průmyslové a obranné bezpečnosti.",
      "h2": "Nejrychleji rostoucí průkopník akustické AI v Evropě",
      "p1": "JALUD Embedded je oceňovaný evropský technologický lídr se sídlem v Plzni. Držitel ocenění Národní cena za AI, Vizionáři 2023 a EU Seal of Excellence.",
      "p2": "Naše neuronové algoritmy zpracovávají zvuk za <5s přímo na úsporných procesorech ARM a NPU. S rostoucí distributorskou sítí v Evropě a USA nabízíme investorům vysoký potenciál opakovaných softwarových marží.",
      "h3": "Hlavní investiční přednosti",
      "b1_title": "Patentovaná neural edge technologie",
      "b1_desc": "Mikrosekundové DSP zpracování na dostupném hardwaru.",
      "b2_title": "Masivní růst trhu (TAM)",
      "b2_desc": "Smart Cities, doprava, nemocnice, školy a průmysl.",
      "b3_title": "Vysoká opakovatelnost softwaru",
      "b3_desc": "SaaS licenční model spojený s prodejem hardwaru.",
      "benefits": [
        "Vlastní duševní vlastnictví edge AI a patenty",
        "Exponenciální komerční růst na trzích EU, UK a USA",
        "Ověřená ekonomika jednotky a vysoké opakované příjmy ze softwaru"
      ]
    },
    "customer": {
      "title": "Péče o zákazníky a SLA údržba",
      "eyebrow": "PODPORA A GARANCE PRO KONCOVÉ UŽIVATELE",
      "lead": "Komplexní technická podpora, akustické průzkumy lokalit, aktualizace firmwaru a neustálá optimalizace klasifikátorů pro města a podniky.",
      "h2": "Komplexní zákaznická péče a kontinuální optimalizace",
      "p1": "V Sound Event Detector instalací práce nekončí. Náš tým péče o zákazníky zajišťuje vysokou provozní spolehlivost a minimalizaci falešných poplachů pro města, nemocnice i průmyslové podniky.",
      "p2": "Poskytujeme akustické průzkumy lokalit na klíč, doporučení výšky montáže, kalibraci šumu a vzdálenou aktualizaci firmwaru.",
      "h3": "Závazky vůči zákazníkům",
      "b1_title": "Vyhrazená inženýrská péče",
      "b1_desc": "Přímé spojení s technickým inženýrem pro asistentční služby.",
      "b2_title": "Celoživotní učení neuronové sítě",
      "b2_desc": "Neustálá vylepšování AI modelů pro nové typy šumu.",
      "b3_title": "ISO 27001 / ISO 9001 SLA garance",
      "b3_desc": "Certifikované řízení kvality a bezpečnosti informací.",
      "benefits": [
        "Asistence při instalaci na klíč a akustické mapování",
        "Garantovaná SLA technická podpora",
        "Vzdálená aktualizace firmwaru a neustálé vylepšování AI"
      ]
    },
    "partner": {
      "title": "Technologické a OEM partnerství",
      "eyebrow": "OEM A TECHNOLOGICKÁ INTEGRACE",
      "lead": "Společný vývoj specializovaných hardwarových modulů, kamerových čipů, chytrých sloupů a robotů s akustickou AI SED.",
      "h2": "Začleňte detekci zvuku přímo do hardwaru nové generace",
      "p1": "JALUD Embedded spolupracuje s předními výrobci hardwaru, kamer a městského osvětlení na přímé integraci neuronových algoritmů SED.",
      "p2": "Náš úsporný C/C++ neuronový engine funguje na čipech NPU, DSP nebo ARM Cortex, což dává výrobcům konkurenční výhodu bez vysokých nákladů na přenos dat do cloudu.",
      "h3": "Možnosti OEM integrace",
      "b1_title": "Licencování firmwaru pro DSP / NPU",
      "b1_desc": "Integrace algoritmů SED do kamerových procesorů.",
      "b2_title": "Vývoj vlastních akustických datových sad",
      "b2_desc": "Trénink speciálních klasifikátorů pro zvuky strojů.",
      "b3_title": "Společný marketing a licencování patentů",
      "b3_desc": "Společné uvedení produktů na trh a prezentace na veletrzích.",
      "benefits": [
        "Licencování neuronových algoritmů pro NPU a DSP čipy",
        "Vývoj vlastních akustických AI klasifikátorů na míru",
        "Společné patenty a uvádění co-branded produktů na trh"
      ]
    }
  },
  "de": {
    "distributor": {
      "title": "Vertriebspartner-Programm | Sound Event Detector",
      "eyebrow": "VERTRIEBSPARTNER-NETZWERK",
      "lead": "Erweitern Sie Ihr Sicherheitstechnologie-Portfolio um moderne Akustik-Erkennungshardware und kostenlose NFR-Softwarelizenzen (Not For Resale) für alle unterstützten Plattformen (Axis, Hanwha, Hikvision...) mit dediziertem Support.",
      "h2": "Erweitern Sie Ihr Portfolio um erstklassige Akustik-KI",
      "p1": "Als autorisierter SED-Vertriebspartner werden Sie zur primären regionalen Quelle für Edge-KI-Akustiktechnologie. Die Nachfrage nach akustischer Erkennung wächst weltweit in Städten, Krankenhäusern und der Industrie.",
      "p2": "Wir statten Vertriebspartner mit Hardware-Demo-Kits, kostenlosen NFR-Softwarelizenzen (Not For Resale) für Ihre Tests und Produktdemonstrationen auf allen unterstützten Plattformen (Axis, Hanwha, Hikvision usw.) und direktem Zugang zu unseren Entwicklern in Pilsen aus.",
      "h3": "Warum Partner von JALUD Embedded werden?",
      "b1_title": "Gebietsschutz & Projektregistrierung",
      "b1_desc": "Registrierte Projekte erhalten garantierten Margenschutz und regionale Präferenz.",
      "b2_title": "Umfassende Schulung & Zertifizierung",
      "b2_desc": "Technische Vertriebsschulung für Ihr Ingenieur- und Vertriebsteam.",
      "b3_title": "100 % DSGVO-Konformität",
      "b3_desc": "Keine Sprachaufzeichnung garantiert reibungslose kommunale Genehmigungen.",
      "b4_title": "SLA Support",
      "b4_desc": "Direkte Eskalation an unsere R&D-Entwicklungsingenieure.",
      "benefits": [
        "Exklusive gebietsschutzrechte & Projektregistrierungsschutz",
        "Hardware-Demo-Kits & kostenlose NFR-Softwarelizenzen (Not For Resale) für Tests und Produktdemonstrationen auf allen Plattformen (Axis, Hanwha, Hikvision usw.)",
        "Direkter technischer Support und Vertriebsschulungen"
      ]
    },
    "integrator": {
      "title": "Systemintegrator | Integration fortschrittlicher Akustikerfassung",
      "eyebrow": "VMS- & HARDWAREINTEGRATION",
      "lead": "Bieten Sie fortschrittliche Akustikerkennung mit nativer Software für Hanwha-, Axis- und Hikvision-Kameras sowie direkter Integration in führende VMS-Plattformen (Genetec, Milestone, Avigilon, Geutebrück u. v. m.) an.",
      "h2": "Nahtlose VMS-Integration ohne Kameratausch",
      "p1": "Modernste Sicherheitskunden verlangen integrierte Lösungen. SED ermöglicht die nahtlose Einbindung in bestehende VMS-Software ohne Austausch bestehender Kameras.",
      "p2": "Bei einem Vorfall (Schuss, Schrei, Glasbruch) sendet SED sofort VMS-Metadaten, steuert PTZ-Kameras auf die Geräuschquelle und alarmiert die Leitstelle in <5s.",
      "h3": "Vorteile für Integratoren",
      "b1_title": "Native Edge-Apps & Umfassende VMS-Integration",
      "b1_desc": "Native Kamera-Software für Hanwha, Axis und Hikvision mit fertigen Integrationen in führende VMS (Genetec, Milestone, Avigilon, Geutebrück u. v. m.). <a href=\"#solutions\" data-route=\"solutions\" style=\"color: var(--blue-primary); font-weight: 700; text-decoration: underline;\">Mehr in der Lösungsübersicht →</a>",
      "b2_title": "REST API & HTTP Webhooks",
      "b2_desc": "Flexible Anbindung an PSIM- und Smart-City-Plattformen.",
      "b3_title": "Null Wartungsaufwand",
      "b3_desc": "Automatische Selbstdiagnose und neuronale Rauschfilterung.",
      "benefits": [
        "Kostenlose NFR-Softwarelizenzen (Not For Resale) für Tests & Demos auf allen Plattformen (Axis, Hanwha, Hikvision...) & REST-API-Zugang",
        "Sofortige PTZ-Kamerasteuerung & Alarmierung der Leitstelle",
        "Margenschutz & Vorverkaufsunterstützung"
      ]
    },
    "citizen": {
      "title": "Aktiver Bürger | Verbesserung der öffentlichen Sicherheit",
      "eyebrow": "INITIATIVE FÜR GEMEINDESICHERHEIT",
      "lead": "Bürger und Gemeindeleiter identifizieren Sicherheitsrisiko-Zonen für schnellere Polizeieinsätze.",
      "h2": "Städte gemeinsam sicherer machen",
      "p1": "Öffentliche Sicherheit ist eine gemeinsame Verantwortung. Bürgern fallen unbeleuchtete Parks und Brennpunkte auf, an denen es zu Vandalismus kommt.",
      "p2": "Durch Ihren Einsatz für Sound Event Detector in Ihrer Gemeinde helfen Sie der Polizei, 7-mal schneller zu reagieren.",
      "h3": "Wie aktive Bürger helfen können",
      "b1_title": "Bürgeranträge an den Stadtrat",
      "b1_desc": "Laden Sie unsere Vorlage für kommunale Sicherheitsausschüsse herunter.",
      "b2_title": "Gefahrenzonen melden",
      "b2_desc": "Melden Sie unsichere Parks, Schulwege und Haltestellen.",
      "b3_title": "Datenschutz gewährleisten",
      "b3_desc": "Informieren Sie Anwohner, dass SED Sprache nicht aufzeichnet.",
      "benefits": [
        "Vorlagen für Bürgeranträge in Stadtratsitzungen",
        "Informationsmaterialien zur Gemeindesicherheit",
        "100 % DSGVO-konform ohne Sprachaufzeichnung"
      ]
    },
    "investor": {
      "title": "Investor Relations | Skalierung europäischer Deep-Tech-KI",
      "eyebrow": "KAPITALPARTNERSCHAFT",
      "lead": "Partner von JALUD Embedded s.r.o. bei der weltweiten Expansion hochwachsender Akustik-KI.",
      "h2": "Schnellstwachsender Akustik-KI-Pionier Europas",
      "p1": "JALUD Embedded ist ein preisgekrönter europäischer Technologieführer mit Sitz in Pilsen. Gewinner des Nationalen KI-Preises und EU Seal of Excellence.",
      "p2": "Unsere neuronalen Edge-Algorithmen verarbeiten Geräusche in <5s direkt auf ARM- und NPU-Prozessoren. Wir bieten Investoren ein hohes wiederkehrendes Software-Margenpotenzial.",
      "h3": "Investment-Highlights",
      "b1_title": "Patentierte Edge-KI-Technologie",
      "b1_desc": "Mikrossekunden-DSP-Verarbeitung auf kostengünstiger Hardware.",
      "b2_title": "Großes Marktpotenzial (TAM)",
      "b2_desc": "Smart Cities, Verkehr, Krankenhäuser, Schulen und Industrie.",
      "b3_title": "Hohe wiederkehrende Erlöse",
      "b3_desc": "SaaS-Lizenzmodell kombiniert mit Hardware-Vertrieb.",
      "benefits": [
        "Eigenes Edge-KI-Patentportfolio",
        "Exponentielles Wachstum in EU, UK und USA",
        "Bewährte Unit Economics und hohe wiederkehrende Softwareerlöse"
      ]
    },
    "customer": {
      "title": "Kundenerfolg & SLA-Wartung",
      "eyebrow": "SUPPORT FÜR ENDANWENDER",
      "lead": "Umfassender technischer Support, Standortanalysen und kontinuierliche Modelloptimierung.",
      "h2": "Umfassender Support & kontinuierliche Optimierung",
      "p1": "Mit der Installation endet unsere Arbeit nicht. Unser Customer Success Team sorgt für 100 % Zuverlässigkeit und null Fehlalarme.",
      "p2": "Wir bieten schlüsselfertige Standortanalysen, Montageempfehlungen und automatische Over-the-Air-Updates.",
      "h3": "Kundenversprechen",
      "b1_title": "Dedizierter Support-Ingenieur",
      "b1_desc": "Direkter Ansprechpartner für Einrichtung und Betreuung.",
      "b2_title": "Lebenslanges KI-Lernen",
      "b2_desc": "Kontinuierliche Modell-Upgrades für neue Geräuschumgebungen.",
      "b3_title": "ISO 27001 / ISO 9001 Garantiert",
      "b3_desc": "Zertifiziertes Qualitäts- und Sicherheitsmanagement.",
      "benefits": [
        "Schlüsselfertige Installationsunterstützung & Standortkartierung",
        "Garantierter SLA-Helpdesk",
        "Over-the-Air-Updates für KI-Modelle"
      ]
    },
    "partner": {
      "title": "Technologie- & OEM-Partnerschaft",
      "eyebrow": "OEM-INTEGRATION",
      "lead": "Gemeinsame Entwicklung von Hardwaremodulen, Kamera-Chips und Smart-City-Masten.",
      "h2": "Akustikerkennung direkt in Hardware integrieren",
      "p1": "JALUD Embedded arbeitet mit führenden Hardwareherstellern zusammen, um SED-Algorithmen direkt in Geräte der nächsten Generation einzubetten.",
      "p2": "Unsere C/C++ Neural Engine läuft effizient auf NPU-, DSP- oder ARM-Prozessoren ohne hohe Cloud-Bandbreitenkosten.",
      "h3": "OEM-Integrationsoptionen",
      "b1_title": "DSP / NPU Firmware-Lizenzierung",
      "b1_desc": "Einbettung von SED-Algorithmen in Kamera-SoCs.",
      "b2_title": "Individuelle Akustik-Datensätze",
      "b2_desc": "Training spezieller Klassifikatoren für Maschinenlärm.",
      "b3_title": "Gemeinsames Marketing & Patente",
      "b3_desc": "Gemeinsame Produkteinführungen und Messeauftritte.",
      "benefits": [
        "Lizenzierung von NPU/DSP-Algorithmen",
        "Entwicklung maßgeschneiderter Akustik-Klassifikatoren",
        "Gemeinsame Patente und Co-Branding"
      ]
    }
  },
  "es": {
    "distributor": {
      "title": "Programa de Distribuidores | Sound Event Detector",
      "eyebrow": "RED DE SOCIOS DISTRIBUIDORES",
      "lead": "Amplíe su cartera de seguridad con hardware de detección acústica y licencias de software NFR (not for resell) sin costo en todas las plataformas compatibles (Axis, Hanwha, Hikvision...) con soporte y capacitación dedicada.",
      "h2": "Amplíe su portafolio de seguridad con IA acústica de primer nivel",
      "p1": "Como distribuidor autorizado de SED, usted se convierte en la fuente regional líder para la tecnología de seguridad acústica edge AI.",
      "p2": "Equipamos a los distribuidores con kits de demostración de hardware, licencias de software NFR (not for resell) sin costo para sus pruebas y demostraciones de productos en todas las plataformas compatibles (Axis, Hanwha, Hikvision, etc.) y acceso directo a nuestro equipo de desarrollo en Pilsen.",
      "h3": "¿Por qué asociarse con JALUD Embedded?",
      "b1_title": "Exclusividad territorial y protección de proyectos",
      "b1_desc": "Los proyectos registrados reciben protección de margen y preferencia regional.",
      "b2_title": "Capacitación técnica y certificación",
      "b2_desc": "Habilitación comercial y técnica para sus ingenieros.",
      "b3_title": "Cumplimiento de RGPD por diseño",
      "b3_desc": "Cero grabación de voz humana para aprobaciones municipales sin fricción.",
      "b4_title": "Soporte de ingeniería y SLA",
      "b4_desc": "Escalamiento directo con ingenieros de I+D.",
      "benefits": [
        "Derechos exclusivos de distribución y protección de proyectos",
        "Kits demo de hardware y licencias SW NFR (not for resell) sin costo para sus pruebas y demostraciones en todas las plataformas (Axis, Hanwha, Hikvision, etc.)",
        "Mesa técnica de ingeniería y capacitación de ventas"
      ]
    },
    "integrator": {
      "title": "Integrador de Sistemas | Integración de Detección Acústica",
      "eyebrow": "INTEGRACIÓN VMS Y HARDWARE",
      "lead": "Ofrezca detección acústica avanzada con software nativo para cámaras Hanwha, Axis y Hikvision e integración directa en las principales plataformas VMS (Genetec, Milestone, Avigilon, Geutebrück y muchas más).",
      "h2": "Integración VMS sin reemplazar cámaras existentes",
      "p1": "Los clientes modernos exigen soluciones integradas. SED permite añadir detección de audio en tiempo real al VMS sin reemplazar hardware existente.",
      "p2": "Al ocurrir un incidente, SED envía metadatos al VMS, rota cámaras PTZ al vector del sonido y alerta a los operadores en <5s.",
      "h3": "Ventajas para integradores",
      "b1_title": "Aplicaciones Edge Nativas y Amplia Integración VMS",
      "b1_desc": "Software nativo para cámaras Hanwha, Axis y Hikvision con integraciones listas para los principales sistemas VMS (Genetec, Milestone, Avigilon, Geutebrück y muchos más). <a href=\"#solutions\" data-route=\"solutions\" style=\"color: var(--blue-primary); font-weight: 700; text-decoration: underline;\">Más detalles en Soluciones →</a>",
      "b2_title": "REST API y Webhooks HTTP",
      "b2_desc": "Integración flexible en plataformas PSIM o Smart City IoT.",
      "b3_title": "Cero sobrecarga de mantenimiento",
      "b3_desc": "Autodiagnóstico continuo y filtrado neuronal de ruido ambiental.",
      "benefits": [
        "Licencias SW NFR (not for resell) sin costo para pruebas y demostraciones en todas las plataformas compatibles (Axis, Hanwha, Hikvision, etc.) y acceso SDK REST API",
        "Giro automático de cámaras PTZ e integración con sala de control",
        "Protección de márgenes y validación técnica previa"
      ]
    },
    "citizen": {
      "title": "Ciudadano Activo | Mejora de la Seguridad Pública con SED",
      "eyebrow": "INICIATIVA DE SEGURIDAD COMUNITARIA",
      "lead": "Fomentar la colaboración ciudadana para identificar puntos ciegos urbanos y ayudar a la policía a responder más rápido a emergencias.",
      "h2": "Haciendo ciudades más seguras, juntos",
      "p1": "La seguridad ciudadana es un esfuerzo colectivo. Los ciudadanos a menudo detectan áreas no iluminadas donde ocurren disturbios.",
      "p2": "Al solicitar la instalación de Sound Event Detector en su municipio, ayuda a la policía a responder 7 veces más rápido respetando la privacidad.",
      "h3": "Cómo pueden ayudar los ciudadanos",
      "b1_title": "Petición a su ayuntamiento local",
      "b1_desc": "Descargue nuestra plantilla de propuesta municipal.",
      "b2_title": "Identificar puntos de riesgo",
      "b2_desc": "Reportar parques y paradas de transporte público vulnerables.",
      "b3_title": "Garantía de privacidad",
      "b3_desc": "Informar a los vecinos que SED no graba conversaciones.",
      "benefits": [
        "Plantillas de peticiones municipales",
        "Material de concienciación sobre seguridad ciudadana",
        "Compatible con GDPR sin grabación de voz"
      ]
    },
    "investor": {
      "title": "Relación con Inversores | Crecimiento de Deep-Tech Europea",
      "eyebrow": "ASOCIACIÓN DE CAPITAL",
      "lead": "Asóciese con JALUD Embedded s.r.o. para escalar la IA acústica en mercados de seguridad municipales, industriales y de defensa.",
      "h2": "Pionero de IA acústica de mayor crecimiento en Europa",
      "p1": "JALUD Embedded es una empresa tecnológica europea con sede en Pilsen, República Checa, ganadora del Premio Nacional de IA y Vizionáři 2023.",
      "p2": "Nuestros algoritmos neuronales procesan sonido en <5s en microprocesadores ARM y NPU. Ofrecemos a los inversores altos márgenes de software recurrentes.",
      "h3": "Aspectos destacados de inversión",
      "b1_title": "Tecnología patentada Edge AI",
      "b1_desc": "Procesamiento DSP de microsegundos en hardware accesible.",
      "b2_title": "Gran mercado potencial (TAM)",
      "b2_desc": "Ciudades inteligentes, transporte, hospitales y defensa.",
      "b3_title": "Alta recurrencia de software",
      "b3_desc": "Modelo SaaS combinado con venta de hardware.",
      "benefits": [
        "Propiedad intelectual propia y patentes registradas",
        "Expansión en mercados de la UE, Reino Unido y EE. UU.",
        "Economía unitaria probada y altos ingresos recurrentes"
      ]
    },
    "customer": {
      "title": "Éxito del Cliente y Mantenimiento SLA",
      "eyebrow": "SOPORTE AL USUARIO FINAL",
      "lead": "Soporte técnico integral, estudios acústicos de emplazamientos y actualizaciones de firmware continuas.",
      "h2": "Soporte empresarial continuo y optimización",
      "p1": "En Sound Event Detector, la instalación es solo el comienzo. Aseguramos máxima fiabilidad operativa para municipios y empresas.",
      "p2": "Proporcionamos estudios acústicos llave en mano, calibración de ruido de fondo y actualizaciones inalámbricas de modelos de IA.",
      "h3": "Compromisos con el cliente",
      "b1_title": "Ingeniería de soporte dedicada",
      "b1_desc": "Contacto directo con ingenieros para asistencia de configuración.",
      "b2_title": "Reentrenamiento neuronal de por vida",
      "b2_desc": "Mejoras continuas para nuevos entornos sonoros.",
      "b3_title": "Garantías SLA ISO 27001 / ISO 9001",
      "b3_desc": "Gestión certificada de calidad y ciberseguridad.",
      "benefits": [
        "Asistencia en instalación y mapeo acústico",
        "Respuesta técnica garantizada por SLA",
        "Actualizaciones de firmware y mejoras de IA"
      ]
    },
    "partner": {
      "title": "Programa de Alianzas Tecnológicas y OEM",
      "eyebrow": "INTEGRACIÓN OEM",
      "lead": "Co-desarrolle módulos de hardware especializados, chips de cámara y luminarias inteligentes con la IA acústica de SED.",
      "h2": "Incorpore detección acústica en hardware de nueva generación",
      "p1": "JALUD Embedded colabora con fabricantes de cámaras, iluminación inteligente y robótica de seguridad para integrar algoritmos neuronales directamente en sus dispositivos.",
      "p2": "Nuestro motor neuronal en C/C++ funciona eficientemente en procesadores NPU, DSP o ARM Cortex sin altos costes de ancho de banda en la nube.",
      "h3": "Opciones de integración OEM",
      "b1_title": "Licenciamiento de firmware para DSP / NPU",
      "b1_desc": "Integración de algoritmos SED en SoC de cámaras.",
      "b2_title": "I+D de conjuntos de datos acústicos a medida",
      "b2_desc": "Entrenamiento de clasificadores para maquinaria industrial.",
      "b3_title": "Marketing conjunto y patentes",
      "b3_desc": "Lanzamiento conjunto de productos y ferias internacionales.",
      "benefits": [
        "Licenciamiento de algoritmos para chips NPU y DSP",
        "Desarrollo de clasificadores acústicos a medida",
        "Patentes conjuntas y co-branding"
      ]
    }
  },
  "pt": {
    "distributor": {
      "title": "Programa de Distribuidores | Sound Event Detector",
      "eyebrow": "REDE DE PARCEIROS DISTRIBUIDORES",
      "lead": "Expanda o seu portfólio de segurança com hardware de deteção acústica e licenças de software NFR (not for resell) sem custo em todas as plataformas suportadas (Axis, Hanwha, Hikvision...) com suporte e formação técnica dedicada.",
      "h2": "Expanda o seu portfólio de segurança com IA acústica de ponta",
      "p1": "Como distribuidor autorizado da SED, torna-se a principal referência regional em tecnologia acústica edge AI.",
      "p2": "Equipamos os distribuidores com kits de demonstração de hardware, licenças de software NFR (not for resell) sem custo para os seus testes e demonstrações de produtos em todas as plataformas suportadas (Axis, Hanwha, Hikvision, etc.) e acesso direto à nossa equipa de engenharia em Pilsen.",
      "h3": "Porquê ser parceiro da JALUD Embedded?",
      "b1_title": "Exclusividade territorial e proteção de projetos",
      "b1_desc": "Projetos registados recebem proteção de margem e prioridade regional.",
      "b2_title": "Formação e certificação abrangentes",
      "b2_desc": "Capacitação técnica e comercial para a sua equipa.",
      "b3_title": "Conformidade com RGPD por Design",
      "b3_desc": "Sem gravação de voz humana, facilitando aprovações municipais.",
      "b4_title": "Suporte de engenharia e SLA",
      "b4_desc": "Contacto direto com engenheiros de I&D.",
      "benefits": [
        "Direitos exclusivos de distribuição e proteção de projetos",
        "Kits demo de hardware e licenças SW NFR (not for resell) sem custo para testes e demonstrações em todas as plataformas (Axis, Hanwha, Hikvision, etc.)",
        "Mesa técnica de engenharia e formação de vendas"
      ]
    },
    "integrator": {
      "title": "Integrador de Sistemas | Integração de Deteção Acústica",
      "eyebrow": "INTEGRAÇÃO VMS E HARDWARE",
      "lead": "Ofereça deteção acústica avançada com software nativo para câmaras Hanwha, Axis e Hikvision e integração direta nas principais plataformas VMS (Genetec, Milestone, Avigilon, Geutebrück e muitas outras).",
      "h2": "Integração VMS perfeita sem trocar câmaras existentes",
      "p1": "Clientes modernos exigem soluções integradas. A SED permite adicionar deteção acústica sem substituir o hardware de vídeo existente.",
      "p2": "Perante um evento, a SED envia metadados para o VMS, direciona câmaras PTZ para o vetor sonoro e notifica os operadores em <5s.",
      "h3": "Vantagens para integradores",
      "b1_title": "Aplicações Edge Nativas e Ampla Integração VMS",
      "b1_desc": "Software nativo para câmaras Hanwha, Axis e Hikvision com integrações prontas para os principais sistemas VMS (Genetec, Milestone, Avigilon, Geutebrück e muitos outros). <a href=\"#solutions\" data-route=\"solutions\" style=\"color: var(--blue-primary); font-weight: 700; text-decoration: underline;\">Mais detalhes na Visão Geral de Soluções →</a>",
      "b2_title": "REST API e Webhooks HTTP",
      "b2_desc": "Integração flexível em plataformas PSIM ou Smart City IoT.",
      "b3_title": "Zero sobrecarga de manutenção",
      "b3_desc": "Autodiagnóstico contínuo e filtragem neural de ruído.",
      "benefits": [
        "Licenças SW NFR (not for resell) sem custo para testes e demonstrações em todas as plataformas suportadas (Axis, Hanwha, Hikvision, etc.) e acesso SDK REST API",
        "Orientação automática de câmaras PTZ e integração com a sala de controlo",
        "Proteção de margens de projeto e validação arquitetural"
      ]
    },
    "citizen": {
      "title": "Cidadão Ativo | Melhorar a Segurança Pública com a SED",
      "eyebrow": "INICIATIVA DE SEGURANÇA COMUNITÁRIA",
      "lead": "Envolver os cidadãos na identificação de pontos cegos de segurança para resposta policial mais rápida.",
      "h2": "Tornando as cidades mais seguras, juntos",
      "p1": "A segurança pública é uma responsabilidade coletiva. Os cidadãos notam frequentemente áreas escuras ou praças onde ocorrem incidentes.",
      "p2": "Ao defender a implementação da Sound Event Detector no seu município, ajuda a polícia a agir 7 vezes mais rápido mantendo a máxima privacidade.",
      "h3": "Como os cidadãos podem ajudar",
      "b1_title": "Proposta para a câmara municipal",
      "b1_desc": "Descarregue o nosso modelo de proposta para comissões de segurança.",
      "b2_title": "Identificar pontos de risco",
      "b2_desc": "Reportar parques e paragens de autocarro vulneráveis.",
      "b3_title": "Garantir a privacidade",
      "b3_desc": "Informar os vizinhos de que a SED não grava conversas.",
      "benefits": [
        "Modelos de propostas municipais",
        "Material de sensibilização para a segurança local",
        "Em conformidade com RGPD sem gravação de voz"
      ]
    },
    "investor": {
      "title": "Relações com Investidores | Expansão de Deep-Tech Europeia",
      "eyebrow": "PARCERIA DE CAPITAL",
      "lead": "Associe-se à JALUD Embedded s.r.o. na expansão da IA acústica em mercados municipais, industriais e de defesa.",
      "h2": "Pioneiro de IA acústica com mais rápido crescimento na Europa",
      "p1": "A JALUD Embedded é líder europeia em tecnologia, sediada em Pilsen, República Checa, galardoada com o Prémio Nacional de IA e Vizionáři 2023.",
      "p2": "Os nossos algoritmos neurais processam áudio em <5s em processadores ARM e NPU, proporcionando altas margens de software recorrentes.",
      "h3": "Destaques de investimento",
      "b1_title": "Tecnologia patenteada Edge AI",
      "b1_desc": "Processamento DSP de microssegundos em hardware de baixo custo.",
      "b2_title": "Grande mercado potencial (TAM)",
      "b2_desc": "Cidades inteligentes, transportes, hospitais e defesa.",
      "b3_title": "Alta receita recorrente de software",
      "b3_desc": "Modelo de subscrição SaaS associado à venda de hardware.",
      "benefits": [
        "Propriedade intelectual própria e patentes registadas",
        "Expansão comercial nos mercados da UE, Reino Unido e EUA",
        "Métricas unitárias comprovadas e receita de software recorrente"
      ]
    },
    "customer": {
      "title": "Sucesso do Cliente e Manutenção SLA",
      "eyebrow": "SUPORTE AO UTILIZADOR FINAL",
      "lead": "Suporte técnico completo, estudos acústicos de locais e otimização contínua dos modelos neurais.",
      "h2": "Suporte empresarial contínuo e otimização",
      "p1": "Na Sound Event Detector, a instalação é apenas o início. Asseguramos alta fiabilidade operacional para municípios e empresas.",
      "p2": "Disponibilizamos estudos acústicos chave-na-mão, calibração de ruído de fundo e atualizações automáticas de firmware e modelos de IA.",
      "h3": "Compromissos com o cliente",
      "b1_title": "Engenheiro de suporte dedicado",
      "b1_desc": "Contacto direto com engenheiros para assistência de configuração.",
      "b2_title": "Aprendizagem contínua da rede neural",
      "b2_desc": "Melhorias contínuas para novos ambientes sonoros.",
      "b3_title": "Garantias SLA ISO 27001 / ISO 9001",
      "b3_desc": "Gestão certificada de qualidade e segurança da informação.",
      "benefits": [
        "Assistência na instalação e mapeamento acústico",
        "Resposta técnica garantida por SLA",
        "Atualizações de firmware e melhorias de IA"
      ]
    },
    "partner": {
      "title": "Programa de Parcerias Tecnológicas e OEM",
      "eyebrow": "INTEGRAÇÃO OEM",
      "lead": "Co-desenvolva módulos de hardware, chips de câmaras e iluminação inteligente com a IA acústica da SED.",
      "h2": "Incorpore deteção acústica em hardware de próxima geração",
      "p1": "A JALUD Embedded colabora com fabricantes de hardware, câmaras e iluminação inteligente para integrar algoritmos da SED diretamente nos equipamentos.",
      "p2": "O nosso motor neural em C/C++ funciona eficientemente em processadores NPU, DSP ou ARM Cortex sem custos elevados de largura de banda na nuvem.",
      "h3": "Opções de integração OEM",
      "b1_title": "Licenciamento de firmware para DSP / NPU",
      "b1_desc": "Integração de algoritmos da SED em processadores de câmaras.",
      "b2_title": "I&D de conjuntos de dados acústicos personalizados",
      "b2_desc": "Treino de classificadores para maquinaria industrial.",
      "b3_title": "Marketing conjunto e patentes",
      "b3_desc": "Lançamento conjunto de produtos e presença em feiras mundiais.",
      "benefits": [
        "Licenciamento de algoritmos para chips NPU e DSP",
        "Desenvolvimento de classificadores acústicos personalizados",
        "Patentes conjuntas e produtos co-branded"
      ]
    }
  },
  "ar": {
    "distributor": {
      "title": "برنامج الموزعين | Sound Event Detector",
      "eyebrow": "شبكة شركاء التوزيع",
      "lead": "قم بتوسيع محفظتك الأمنية مع أجهزة الكشف الصوتي بالذكاء الاصطناعي وتراخيص برمجيات NFR (not for resell) مجانية عبر جميع المنصات المدعومة (Axis, Hanwha, Hikvision...) مع دعم وتدريب إقليمي مخصص.",
      "h2": "وسع محفظتك الأمنية بأحدث تقنيات الذكاء الاصطناعي الصوتي",
      "p1": "بصفتك موزعاً معتمداً لـ SED، تصبح المصدر الإقليمي الرئيسي لتقنيات الكشف الصوتي بالذكاء الاصطناعي.",
      "p2": "نزود الموزعين بحزم تجريبية وتراخيص برمجيات NFR (not for resell) مجانية لاختباراتكم وعروض منتجاتكم عبر جميع المنصات المدعومة (Axis, Hanwha, Hikvision, etc.) مع وصول مباشر لفريق التطوير في بلزن.",
      "h3": "لماذا تشارك JALUD Embedded؟",
      "b1_title": "حصرية إقليمية وحماية المشاريع",
      "b1_desc": "المشاريع المسجلة تحصل على حماية الهامش وأولوية إقليمية.",
      "b2_title": "تدريب شامل وشهادات معتمدة",
      "b2_desc": "تأهيل تقني وتجاري لمهندسيكم وفريق المبيعات.",
      "b3_title": "الامتثال للائحة GDPR بالتصميم",
      "b3_desc": "عدم تسجيل أي محادثات صوتية لتسهيل الموافقات البلدية.",
      "b4_title": "دعم هندسي بموجب SLA",
      "b4_desc": "تواصل مباشر مع مهندسي البحث والتطوير.",
      "benefits": [
        "حقوق توزيع إقليمية حصرية وحماية تسجيل المشاريع",
        "حزم عروض تجريبية وتراخيص NFR (not for resell) مجانية لاختباراتكم وعروض المنتجات على جميع المنصات (Axis, Hanwha, Hikvision, etc.)",
        "دعم فني هندسي مباشر وتدريب مبيعات"
      ]
    },
    "integrator": {
      "title": "مكامل النظم | تكامل الكشف الصوتي المتقدم",
      "eyebrow": "تكامل VMS والأجهزة",
      "lead": "قدم كشفاً صوتياً متقدماً مع برمجيات أصلية لكاميرات Hanwha و Axis و Hikvision والتكامل المباشر مع أبرز منصات VMS (مثل Genetec و Milestone و Avigilon و Geutebrück وغيرها الكثير).",
      "h2": "تكامل سلس مع أنظمة VMS دون استبدال الكاميرات الحالية",
      "p1": "يتطلب العملاء حلولاً متكاملة. يتيح SED إضافة الكشف الصوتي إلى برامج VMS دون استبدال الكاميرات.",
      "p2": "عند وقوع حدث صوتي، يرسل SED البيانات الوصفية فوراً ويوجه كاميرات PTZ إلى مصدر الصوت وينبه المشغلين في أقل من 5 ثوانٍ.",
      "h3": "مزايا لمكاملي النظم",
      "b1_title": "تطبيقات Edge أصلية وتكامل VMS شامل",
      "b1_desc": "برمجيات أصلية لكاميرات Hanwha و Axis و Hikvision مع تكامل جاهز لأبرز أنظمة VMS (مثل Genetec و Milestone و Avigilon و Geutebrück وغيرها). <a href=\"#solutions\" data-route=\"solutions\" style=\"color: var(--blue-primary); font-weight: 700; text-decoration: underline;\">المزيد في نظرة عامة على الحلول ←</a>",
      "b2_title": "واجهة REST API و Webhooks",
      "b2_desc": "تكامل مرن مع منصات PSIM وإنترنت الأشياء للمدن الذكية.",
      "b3_title": "صيانة معدومة",
      "b3_desc": "تشخيص ذاتي وتصفية الضوضاء المحيطة عصبياً.",
      "benefits": [
        "تراخيص برمجيات NFR (not for resell) مجانية للاختبارات والعروض على جميع المنصات المدعومة (Axis, Hanwha, Hikvision, etc.) ووصول لـ REST API SDK",
        "توجيه فوري لكاميرات PTZ وتكامل مع غرف العمليات",
        "حماية هوامش المشاريع والتحقق الفني المسبق"
      ]
    },
    "citizen": {
      "title": "المواطن الفاعل | تعزيز السلامة العامة مع SED",
      "eyebrow": "مبادرة أمان المجتمع",
      "lead": "تمكين المواطنين وقادة المجتمع من تحديد النقاط الحساسة في المدن ومساعدة الشرطة على التدخل السريع.",
      "h2": "معاً لمدن أكثر أماناً",
      "p1": "السلامة العامة مسؤولية جماعية. يلاحظ المواطنون الأماكن المظلمة التي تتكرر فيها الحوادث.",
      "p2": "بالمطالبة بنشر SED في بلديتك، تساعد الشرطة على الاستجابة أسرع بـ 7 مرات مع حماية تامة للخصوصية.",
      "h3": "كيف يساهم المواطنون",
      "b1_title": "تقديم مقترحات للمجالس البلدية",
      "b1_desc": "حمل نموذج المقترح المخصص للجان السلامة.",
      "b2_title": "تحديد نقاط الخطر",
      "b2_desc": "الإبلاغ عن الحدائق ومحطات النقل المعرضة للمخاطر.",
      "b3_title": "ضمان الخصوصية",
      "b3_desc": "تأكيد أن SED يعالج الصوت محلياً دون تسجيل المحادثات.",
      "benefits": [
        "نماذج مقترحات بلدية رسمية",
        "مواد توعوية وتقارير أمان للمجتمعات",
        "امتثال تام للائحة GDPR دون تسجيل أصوات"
      ]
    },
    "investor": {
      "title": "علاقات المستثمرين | توسيع الذكاء الاصطناعي الأوروبي",
      "eyebrow": "شراكة رأس المال",
      "lead": "شارك JALUD Embedded s.r.o. في التوسع العالمي لتقنيات الذكاء الاصطناعي الصوتي في الأسواق الأمنية والصناعية والدفاعية.",
      "h2": "الرائد الأسرع نمواً في الذكاء الاصطناعي الصوتي في أوروبا",
      "p1": "JALUD Embedded شركة تكنولوجية أوروبية حائزة على جوائز مقرها بلزن، وحاصلة على الجائزة الوطنية للذكاء الاصطناعي و Vizionáři 2023.",
      "p2": "تعالج خوارزمياتنا الصوت في <5 ثوانٍ على معالجات ARM و NPU، مما يوفر هوامش ربح برمجية متكررة عالية للمستثمرين.",
      "h3": "أبرز نقاط الاستثمار",
      "b1_title": "تقنية Edge AI حاصلة على براءات اختراع",
      "b1_desc": "معالجة صوتية دقيقة على أجهزة منخفضة التكلفة.",
      "b2_title": "سوق مستهدف ضخم (TAM)",
      "b2_desc": "المدن الذكية والمستشفيات والنقل والمنشآت الدفاعية.",
      "b3_title": "إيرادات برمجية متكررة",
      "b3_desc": "نموذج SaaS مقترن بمبيعات الأجهزة.",
      "benefits": [
        "ملكية فكرية وبراءات اختراع مسجلة",
        "توسع تجاري في أسواق الاتحاد الأوروبي وبريطانيا وأمريكا",
        "اقتصاديات وحدة مثبتة وإيرادات متكررة عالية"
      ]
    },
    "customer": {
      "title": "نجاح العملاء وصيانة SLA",
      "eyebrow": "دعم المستخدم النهائي",
      "lead": "دعم فني شامل ودراسات صوتية للمواقع وتحديثات مستمرة للنماذج العصبية للبلديات والمؤسسات.",
      "h2": "دعم مؤسسي شامل وتحسين مستمر",
      "p1": "مع SED، التثبيت هو البداية فقط. نحرص على تحقيق أعلى موثوقية تشغيلية والحد من الإنذارات الكاذبة.",
      "p2": "نوفر مسوحات صوتية للمواقع، وتوصيات بارتفاع التثبيت، وتحديثات تلقائية للبرمجيات.",
      "h3": "التزاماتنا للعملاء",
      "b1_title": "هندسة دعم مخصصة",
      "b1_desc": "تواصل مباشر مع المهندسين للمساعدة في الإعداد.",
      "b2_title": "تطوير مستمر للنماذج العصبية",
      "b2_desc": "ترقيات مستمرة لبيئات الضوضاء الجديدة.",
      "b3_title": "ضمانات SLA بمعايير ISO 27001 / ISO 9001",
      "b3_desc": "إدارة جودة وأمن معلومات معتمدة.",
      "benefits": [
        "مساعدة في التثبيت ومسح صوتي للموقع",
        "استجابة فنية مضمونة بموجب SLA",
        "تحديثات برمجية لاسلكية وترقية مستمرة للذكاء الاصطناعي"
      ]
    },
    "partner": {
      "title": "برنامج الشراكة التكنولوجية و OEM",
      "eyebrow": "تكامل OEM",
      "lead": "شارك في تطوير وحدات أجهزة متخصصة ورقائق كاميرات وأعمدة إنارة ذكية مدعومة بالذكاء الاصطناعي من SED.",
      "h2": "دمج الكشف الصوتي في أجهزة الجيل القادم",
      "p1": "تتعاون JALUD Embedded مع كبرى الشركات المصنعة للكاميرات والإنارة الذكية لدمج خوارزميات SED مباشرة في أجهزتها.",
      "p2": "محركنا العصبي المكتوب بـ C/C++ يعمل بكفاءة على معالجات NPU أو DSP أو ARM Cortex دون تكاليف سحابية باهظة.",
      "h3": "خيارات تكامل OEM",
      "b1_title": "ترخيص البرمجيات لـ DSP / NPU",
      "b1_desc": "دمج خوارزميات SED في معالجات الكاميرات.",
      "b2_title": "تطوير قواعد بيانات صوتية مخصصة",
      "b2_desc": "تدريب نماذج خاصة للضوضاء الصناعية.",
      "b3_title": "تسويق مشترك وترخيص براءات الاختراع",
      "b3_desc": "إطلاق منتجات مشتركة والمشاركة في المعارض العالمية.",
      "benefits": [
        "ترخيص الخوارزميات العصبية لرقائق NPU و DSP",
        "تطوير مصنفات صوتية بالذكاء الاصطناعي مخصصة",
        "براءات اختراع مشتركة وإطلاق منتجات بعلامات تجارية مشتركة"
      ]
    }
  }
,
  "it": {
      "distributor": {
          "title": "Programma Distributori | Rilevatore di eventi sonori",
          "eyebrow": "RETE DI PARTNER DISTRIBUTORI",
          "lead": "Espandi il tuo portafoglio di tecnologie di sicurezza con hardware moderno per il rilevamento di eventi sonori e licenze SW NFR (non rivendibili) a costo zero su tutte le piattaforme supportate (Axis, Hanwha, Hikvision...) supportate da supporto regionale dedicato, formazione e cooperazione affidabile.",
          "h2": "Espandi il tuo portafoglio di sicurezza con un'intelligenza artificiale acustica di livello mondiale",
          "p1": "In qualità di distributore SED autorizzato, diventi la principale fonte regionale di tecnologia di sicurezza acustica AI all'avanguardia. La richiesta di una classificazione non invasiva degli eventi sonori sta accelerando a livello globale nei mercati municipali, sanitari, industriali e bancari.",
          "p2": "Forniamo ai distributori kit dimostrativi hardware, licenze SW NFR (non rivendibili) a costo zero per i test e dimostrazioni di prodotti su tutte le piattaforme supportate (Axis, Hanwha, Hikvision, ecc.) e accesso diretto al nostro team di ingegneri a Pilsen, Repubblica Ceca.",
          "h3": "Perché collaborare con JALUD Embedded?",
          "b1_title": "Esclusività territoriale e protezione dell'affare",
          "b1_desc": "I progetti registrati ricevono la protezione del margine commerciale e la preferenza regionale.",
          "b2_title": "Formazione e certificazione complete",
          "b2_desc": "Abilitazione tecnico-commerciale per il vostro personale tecnico e commerciale.",
          "b3_title": "Privacy fin dalla progettazione e conformità al GDPR",
          "b3_desc": "L'assenza di registrazione del parlato umano garantisce approvazioni di implementazione municipali senza problemi.",
          "b4_title": "Supporto di ingegneria e SLA",
          "b4_desc": "Escalation dirette ai principali ingegneri sviluppatori di ricerca e sviluppo.",
          "benefits": [
              "Diritti esclusivi di distribuzione territoriale e tutela della registrazione del progetto",
              "Kit demo hardware e licenze SW NFR a costo zero (non rivendibili) per test e dimostrazioni di prodotti su tutte le piattaforme supportate (Axis, Hanwha, Hikvision, ecc.)",
              "Desk di supporto ingegneristico e formazione alle vendite"
          ]
      },
      "integrator": {
          "title": "Integratore di sistema | Integrazione della soluzione avanzata di rilevamento del suono",
          "eyebrow": "INTEGRAZIONE VMS E HARDWARE",
          "lead": "Offri il rilevamento avanzato delle minacce acustiche con software nativo per telecamere Hanwha, Axis e Hikvision e l'integrazione diretta nelle principali piattaforme VMS (Genetec, Milestone, Avigilon, Geutebrück e molte altre).",
          "h2": "Integrazione VMS perfetta senza modificare le telecamere esistenti",
          "p1": "I moderni client di sicurezza richiedono soluzioni integrate anziché silos isolati. SED consente agli integratori di sistemi di aggiungere facilmente il rilevamento acustico al software di gestione video (VMS) esistente senza sostituire l'hardware della telecamera esistente.",
          "p2": "Quando si verifica un evento acustico (sparo da arma da fuoco, urlo, rottura di vetri), SED invia immediatamente i metadati VMS, attiva la rotazione istantanea della telecamera PTZ sulle coordinate del suono e avvisa gli operatori centrali in meno di 5 secondi.",
          "h3": "Vantaggi dell'integratore",
          "b1_title": "App Native Edge e integrazione VMS completa",
          "b1_desc": "Software per fotocamera nativo per Hanwha, Axis e Hikvision con integrazioni predefinite per i principali sistemi VMS (Genetec, Milestone, Avigilon, Geutebrück e molti altri). <a href=\"#solutions\" data-route=\"solutions\" style=\"color: var(--blue-primary); font-weight: 700; text-decoration: underline;\">Ulteriori informazioni nella Panoramica delle soluzioni →</a>",
          "b2_title": "API REST e webhook HTTP",
          "b2_desc": "Integrazione flessibile in piattaforme PSIM personalizzate o IoT per città intelligenti.",
          "b3_title": "Zero costi di manutenzione",
          "b3_desc": "Autodiagnostica automatica e filtraggio del rumore neurale.",
          "benefits": [
              "Licenze SW NFR (non rivendibili) a costo zero per test e dimostrazioni di prodotti su tutte le piattaforme supportate (Axis, Hanwha, Hikvision, ecc.) e accesso all'SDK API REST",
              "Rotazione istantanea della telecamera PTZ e integrazione degli avvisi della sala di controllo centrale",
              "Protezione del margine di trattativa e convalida dell'architettura prevendita"
          ]
      },
      "citizen": {
          "title": "Cittadino attivo | Migliorare la sicurezza pubblica con il SED",
          "eyebrow": "INIZIATIVA COMUNITARIA PER LA SICUREZZA",
          "lead": "Consentire ai cittadini, alle guardie di quartiere e ai leader delle comunità locali di identificare i punti ciechi ad alto rischio per la sicurezza urbana e di collaborare con la polizia municipale per una risposta più rapida alle crisi.",
          "h2": "Rendere le città più sicure, insieme",
          "p1": "La sicurezza pubblica è una responsabilità collettiva. I cittadini notano spesso i parchi cittadini, i viali della vita notturna e le fermate dei mezzi pubblici non illuminati dove si verificano ripetutamente criminalità, alterchi di panico o atti di vandalismo.",
          "p2": "Sostenendo l'implementazione del rilevatore di eventi sonori nel tuo comune, aiuti la polizia locale a rispondere 7 volte più velocemente agli incidenti mantenendo rigorosi standard di privacy ai sensi del GDPR.",
          "h3": "Come i cittadini attivi possono aiutare",
          "b1_title": "Fai una petizione al tuo consiglio comunale locale",
          "b1_desc": "Scarica il nostro modello di proposta municipale per i comitati locali di sicurezza.",
          "b2_title": "Identificare i punti ciechi di sicurezza",
          "b2_desc": "Segnala parchi pubblici, scuole e snodi di trasporto pubblico ad alto rischio.",
          "b3_title": "Rassicurare le preoccupazioni sulla privacy",
          "b3_desc": "Informa i vicini che i processi SED risuonano localmente sui chip edge senza registrare le conversazioni.",
          "benefits": [
              "Modelli di petizioni comunali dirette per le riunioni del consiglio comunale",
              "Materiale di sensibilizzazione sulla sicurezza della comunità e rapporti dimostrativi",
              "Architettura di registrazione vocale zero allineata al GDPR"
          ]
      },
      "investor": {
          "title": "Relazioni con gli investitori | Scalare l’IA europea deep-tech",
          "eyebrow": "PARTNERSHIP DI VENTURE E CAPITALE",
          "lead": "Partner di JALUD Embedded s.r.o. nell’espansione della tecnologia dell’intelligenza artificiale acustica in forte crescita nei mercati globali della sicurezza municipale, della difesa e industriale.",
          "h2": "Pioniere della tecnologia acustica profonda in più rapida crescita in Europa",
          "p1": "JALUD Embedded è un pluripremiato leader tecnologico europeo con sede a Pilsen, Repubblica Ceca. Vincitore del Premio Nazionale AI, Vizionáři 2023, e del Sigillo di Eccellenza UE.",
          "p2": "I nostri algoritmi proprietari di bordo neurale elaborano il suono in meno di 5 secondi direttamente su microprocessori ARM e NPU a basso consumo. Con canali di distribuzione in espansione in Europa, Nord America e Asia, JALUD Embedded offre agli investitori un elevato potenziale di margine software ricorrente e barriere IP difendibili.",
          "h3": "Punti salienti degli investimenti",
          "b1_title": "Tecnologia Neural Edge brevettata",
          "b1_desc": "Elaborazione DSP audio in microsecondi su hardware a basso costo.",
          "b2_title": "Massiccia espansione TAM",
          "b2_desc": "Città intelligenti, trasporti pubblici, ospedali, scuole e installazioni di difesa.",
          "b3_title": "Elevata ricorrenza del software",
          "b3_desc": "Modello di licenza SaaS abbinato alla vendita di hardware.",
          "benefits": [
              "Proprietà intellettuale e brevetti proprietari dell'intelligenza artificiale",
              "Espansione commerciale esponenziale nei mercati di UE, Regno Unito e Stati Uniti",
              "Economia unitaria comprovata e ricavi software ricorrenti elevati"
          ]
      },
      "customer": {
          "title": "Successo dei clienti e mantenimento degli SLA aziendali",
          "eyebrow": "SUPPORTO E RASSICURAZIONE PER L'UTENTE FINALE",
          "lead": "Supporto tecnico completo, indagini acustiche sul sito, aggiornamenti firmware e ottimizzazione continua del classificatore neurale per clienti municipali e aziendali.",
          "h2": "Supporto aziendale end-to-end e ottimizzazione continua",
          "p1": "Per Sound Event Detector, l'implementazione è solo l'inizio. Il nostro Customer Success Team garantisce che ogni consiglio comunale, pronto soccorso ospedaliero, impianto energetico e cliente al dettaglio raggiunga un'elevata affidabilità operativa.",
          "p2": "Forniamo indagini acustiche del sito chiavi in ​​mano, raccomandazioni sull'altezza di montaggio, calibrazione del rumore di fondo e aggiornamenti automatici del firmware via etere per garantire che il sistema migliori nel tempo.",
          "h3": "Impegni di rassicurazione del cliente",
          "b1_title": "Ingegneria contabile dedicata",
          "b1_desc": "Contatto diretto con ingegneri tecnici per assistenza nella configurazione.",
          "b2_title": "Riqualificazione neurale a vita",
          "b2_desc": "Aggiornamenti continui del modello per nuovi ambienti acustici.",
          "b3_title": "Garanzie SLA ISO 27001 / ISO 9001",
          "b3_desc": "Gestione della qualità certificata e standard di sicurezza informatica.",
          "benefits": [
              "Assistenza per l'installazione chiavi in ​​mano e mappatura acustica del sito",
              "Supporto tecnico dedicato per i clienti a contratto",
              "Aggiornamenti del firmware via etere e aggiornamenti continui del modello neurale"
          ]
      },
      "partner": {
          "title": "Programma di partnership tecnologica e OEM",
          "eyebrow": "ALLINEAMENTO OEM E TECNOLOGIA",
          "lead": "Co-sviluppa moduli hardware specializzati, chip per telecamere, pali di illuminazione per città intelligenti e robotica di sicurezza alimentati da algoritmi neurali AI acustici SED.",
          "h2": "Integra il rilevamento del suono nell'hardware di nuova generazione",
          "p1": "JALUD Embedded collabora con i principali produttori di hardware, fornitori di telecamere, fornitori di lampioni intelligenti e aziende di robotica di sicurezza per incorporare algoritmi neurali del rilevatore di eventi sonori direttamente nei dispositivi di prossima generazione.",
          "p2": "Il nostro leggero motore neurale C/C++ può funzionare in modo efficiente su processori NPU, DSP o ARM Cortex a basso consumo, offrendo ai partner hardware un vantaggio competitivo senza pesanti costi di larghezza di banda cloud.",
          "h3": "Opzioni di integrazione OEM",
          "b1_title": "Licenza firmware DSP/NPU",
          "b1_desc": "Incorpora algoritmi SED nei SoC delle fotocamere o nei lampioni intelligenti.",
          "b2_title": "Ricerca e sviluppo di set di dati audio personalizzati",
          "b2_desc": "Addestra classificatori personalizzati per macchinari industriali o eventi proprietari.",
          "b3_title": "Marketing co-branded e licenza di brevetto",
          "b3_desc": "Rilasci congiunti di prodotti GTM e vetrine fieristiche globali.",
          "benefits": [
              "Licenza per algoritmo neurale NPU/DSP integrato",
              "Classificatore acustico AI personalizzato Ricerca e sviluppo e raccolta di set di dati",
              "Lancio congiunto di brevetti e tecnologie co-branded"
          ]
      }
  }
};
